// Admin emails - same as server (default two admins; optional extra via env)
const ADMIN_EMAILS = [
  'admin@example.com',
  'admin2@example.com',
  ...(process.env.REACT_APP_ADMIN_EMAIL ? [process.env.REACT_APP_ADMIN_EMAIL] : [])
];

export const isAdmin = (user) => user && ADMIN_EMAILS.includes(user.email);

export const isAdminEmail = (email) => email && ADMIN_EMAILS.includes(email);
